import * as React from 'react';
import { BaseComponent } from '../BaseComponent';
import { ViewSettingsStore } from '../../stores/ViewSettingsStore';
import { LoadingAnimation } from '../LoadingAnimation';
import { UIHelper } from '../../utils/UIHelper';
import { SidebarModule } from '../../constants/Enums';

interface SidebarLockState {
    locked: boolean;
}

export class SidebarLock extends BaseComponent<{}, SidebarLockState> {
    public componentWillMount(): void {
        this.addStoreListener(ViewSettingsStore, this.onChange);
        this.onChange();
    }

    public render(): JSX.Element | null {
        if (this.state.locked) {
            return (
                <div className="sidebar-tab-container sidebar-lock" onClick={UIHelper.stopEvent} onTouchMove={UIHelper.stopEvent}>
                    <LoadingAnimation />
                </div>
            );
        }
        return null;
    }

    protected onChange = (): void => {
        this.setState({
            locked: (ViewSettingsStore.getState().sidebarlocked && ViewSettingsStore.getState().sidebar !== SidebarModule.NONE)
        });
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/sidebar/SidebarLock.tsx